import { KeyboardEvent } from 'react';

import { matchPath } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment-timezone';
import orderBy from 'lodash/orderBy';
import validator from 'validator';
import { History, LocationState } from 'history';

import { MOBILE_RESOLUTION, UTC } from '../constants/common';
import { BookingOption, LocationType } from '../../types/Activity';

export type SelectOption = {
  label: string;
  value: string;
};

export class LocationDescription {
  constructor(val) {
    if (val) {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.address = this.refreshAddress(val);
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.url = val.url;
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.name = val.name;
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.latitude = val.geometry.location.lat();
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.longitude = val.geometry.location.lng();
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.tz = null;
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.offset = val.utc_offset_minutes;
    } else {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.address = undefined;
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.name = undefined;
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.latitude = undefined;
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.longitude = undefined;
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.url = undefined;
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      this.tz = undefined;
    }
  }

  refreshAddress = data => {
    if (data.formatted_address.substr(-3) === 'USA') {
      return data.formatted_address.slice(0, -5);
    }
    return data.formatted_address;
  };
}

export function getFormattedAddress(data) {
  if (data.formatted_address.substr(-3) === 'USA') {
    return data.formatted_address.slice(0, -5);
  }
  const words = data.formatted_address.split(',');
  return `${words[0]},${words[words.length - 1]}`;
}

export function GetCityByPlace(description) {
  let city = '';
  description.address_components.forEach(component => {
    if (
      component.types.indexOf('political') !== -1 &&
      component.types.indexOf('locality') !== -1
    ) {
      city = component.long_name;
    }
    if (
      component.types.indexOf('political') !== -1 &&
      component.types.indexOf('administrative_area_level_1') !== -1
    ) {
      city = `${city}, ${component.short_name}`;
    }
    if (
      component.types.indexOf('political') !== -1 &&
      component.types.indexOf('country') !== -1
    ) {
      if (component.short_name !== 'US') {
        city = `${city}, ${component.long_name}`;
      }
    }
  });
  return city;
}

function getTimeZone(lat, lng) {
  const timestamp = new Date().getTime() / 1000;
  return axios.get(
    `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},
    ${lng}&timestamp=${timestamp}&key=AIzaSyBAAIr9HbcVCnLHgCw8WXXdLV47unpA_I8`
  );
}

export async function getTimeZoneData(lat, lng) {
  const timezone = await getTimeZone(lat, lng);
  return timezone;
}

export async function getLocationDescription(val, isCity) {
  let location = new LocationDescription(val);
  if (isCity) {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const timeZone = await getTimeZone(location.latitude, location.longitude);
    location = {
      ...location,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      tz: timeZone.data.timeZoneId,
    };
  }
  return location;
}

export function querystring(name, url = window.location.href) {
  const str = name.replace(/[[]]/g, '\\$&');
  const regex = new RegExp(`[?&]${str}(=([^&#]*)|&|#|$)`, 'i');
  const results = regex.exec(url);

  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
/* eslint-enable */

export function getDate(date) {
  return `${date.getDay()}/${date.getMonth()}/
  ${date.getFullYear()}  ${date.getHours()}:${date.getMinutes()}`;
}

export function getMatchByPath(path, template, exact = true, strict = false) {
  return matchPath(path, {
    path: template,
    exact,
    strict,
  });
}

export function getAllDatesFromInterval(startDate, endDate, tz) {
  const dates = [];
  const date = moment(startDate).tz(tz).startOf('day');
  const end = moment(endDate).tz(tz).endOf('day').millisecond(0);
  while (date.valueOf() <= end.valueOf()) {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    dates.push(moment(date).toISOString());
    date.add(1, 'days');
    if (date.dayOfYear() === end.dayOfYear()) {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      dates.push(moment(end).toISOString());
      return dates;
    }
  }
  return dates;
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export function validatePhoneNumber(number) {
  if (number.match(/^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){0,14}(\s*)?$/)) {
    return true;
  }
  return false;
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export function getMapUrl(url) {
  return `${url}&output=embed`;
}

export function getMilisecondsFromUTCTime(hour, minute) {
  return hour * 3600 + minute * 60;
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export function getNewUTCTime(date, seconds) {
  const newdate = moment(date)
    .tz(UTC)
    .hour(Math.floor(seconds / 3600))
    .minute((seconds % 3600) / 60);
  return newdate.format('YYYY-MM-DDTHH:mm:00.000Z');
}

export function compinsateDst(date, seconds, tz) {
  const t = moment(date).tz(tz);
  const janOffset = moment('2019-01-01').tz(tz).utcOffset();
  const julOffset = moment('2019-06-01').tz(tz).utcOffset();
  const off = Math.max(janOffset, julOffset);
  let dstMinutes = 0;
  if (julOffset < janOffset) {
    dstMinutes = t.utcOffset() - off;
  }
  if (dstMinutes < 0) {
    dstMinutes = 0;
  }
  const test = moment
    .tz(date.slice(0, 10), tz)
    .hour(Math.floor(seconds / 3600))
    .minute((seconds % 3600) / 60 - dstMinutes)
    .toISOString();
  return test;
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export function unCompinsateDst(dt, tz) {
  const t = moment(dt).tz(tz);
  const janOffset = moment('2019-01-01').tz(tz).utcOffset();
  const julOffset = moment('2019-06-01').tz(tz).utcOffset();
  const off = Math.max(janOffset, julOffset);
  let dstMinutes = 0;
  if (julOffset < janOffset) {
    dstMinutes = t.utcOffset() - off;
  }
  const min = moment(dt).tz(UTC).minute();
  return moment(dt)
    .tz(UTC)
    .minute(min - dstMinutes)
    .toISOString();
}

export function getTimeWithOffset(time) {
  if (time === null) {
    return null;
  }
  const offset = new Date().getTimezoneOffset() * 60000;
  const date = new Date(time.slice(0, 10));
  date.setTime(date.getTime() + offset);
  date.setHours(12);
  date.setMinutes(0);
  return date;
}

export function generateEndTimeForGroundTransport(date, tz, duration) {
  if (duration >= 0) {
    return moment.tz(date, tz).add(duration, 'minutes').toISOString();
  }
  return moment.tz(date, tz).add(30, 'minutes').toISOString();
}

export function getTimeWithoultOffset(time) {
  // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
  const offset = new Date().getTimezoneOffset();
  return moment.tz(time, UTC).toISOString();
}
export async function getCityLocation(city) {
  // eslint-disable-next-line no-undef
  const geocoder = new google.maps.Geocoder();
  return new Promise((resolve, reject) => {
    geocoder.geocode({ address: city }, (results, status) => {
      if (status === 'OK') {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        resolve(results[0].geometry.location);
      }
      reject(new Error('Bad request'));
    });
  });
}

export function getCurrentDate(date, tz) {
  return moment
    .tz(date.slice(0, 10), tz)
    .add(1, 'day')
    .hour(0)
    .minute(0)
    .toISOString();
}

export function getDateInUTC(date, seconds) {
  const offset = new Date().getTimezoneOffset() * 60000;
  const off = moment(date).tz(UTC).utcOffset();
  date.setHours(seconds / 3600);
  date.setMinutes((seconds % 3600) / 60);
  date.setTime(date.getTime() - offset - off * 60000);
  return date;
}

export function getDisabledDaysOfWeek(days) {
  if (!days || days.startsWith('BEGIN:VCALENDAR')) return [];

  const availableDays = days
    .replace(' ', '')
    .split(',')
    .map(day => {
      switch (day) {
        case 'SUN':
          return 0;
        case 'MON':
          return 1;
        case 'TUE':
          return 2;
        case 'WED':
          return 3;
        case 'THU':
          return 4;
        case 'FRI':
          return 5;
        case 'SAT':
          return 6;
        default:
          return -1;
      }
    });
  const ALL_DAYS = [0, 1, 2, 3, 4, 5, 6];
  if (availableDays.length === 1 && availableDays[0] === -1) {
    return [];
  }
  const blockedDays = ALL_DAYS.filter(
    day => !availableDays.some(d => d === day)
  );
  return blockedDays;
}

export function getTimeIntervalForParty(party, events) {
  if (party.startDate !== null) {
    return getAllDatesFromInterval(party.startDate, party.endDate, party.tz);
  }
  const startEvents = events
    .filter(event => !event.dateTBD)
    .map(ev => ev.startTime);
  const endEvents = events
    .filter(event => !event.dateTBD)
    .map(ev => ({ time: ev.endTime, tz: ev.endTz }));
  if (startEvents.length && startEvents.length !== 0) {
    const min = moment
      .min(startEvents.map(date => moment.tz(date, party.tz)))
      .toISOString();
    const max = moment
      .max(endEvents.map(el => moment.tz(el.time, party.tz)))
      .toISOString();
    return getAllDatesFromInterval(min, max, party.tz);
  }
  return [];
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export function generateKeyStr() {
  const chrs = 'abdehkmnpswxzABDEFGHKMNPQRSTWXZ123456789';
  let str = '';
  for (let i = 0; i < 10; i++) {
    const pos = Math.floor(Math.random() * chrs.length);
    str += chrs.substring(pos, pos + 1);
  }
  return str;
}

export function getTableSort(name, activeSort, availableSort) {
  return activeSort.name === name
    ? { ...activeSort, up: !activeSort.up }
    : availableSort.find(s => s.name === name);
}

export function pluralizeChecked(count, noun, suffix = 's') {
  return `${noun}${count !== 1 ? suffix : ''}`;
}

export function getMixPanelEncodingTitle(str) {
  if (!str) return '';
  return str
    .split(' ')
    .map(word => word.replace(',', '*2c'))
    .join('*20');
}

export function isObjectEmpty(obj) {
  if (!obj) return true;
  return !Object.values(obj).some(x => x);
}

export function trackMixpanel(name, info, currentUser, mixpanel) {
  if (!currentUser) return;
  const { username, attributes } = currentUser;
  const { email } = attributes;
  const infoWithUserData = { id: username, email, ...info };
  mixpanel.track(name, infoWithUserData);
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function isMobileResolution() {
  return window.matchMedia(`(max-width: ${MOBILE_RESOLUTION})`).matches;
}

export function sortArray(data, name, up) {
  if (!data) return [];
  return up ? orderBy(data, name) : orderBy(data, name, 'desc');
}

export function openLink(
  event: KeyboardEvent,
  url: string,
  history: History<LocationState>,
  newTab?: unknown
) {
  if (event.metaKey || event.ctrlKey || newTab) {
    const win = window.open(url, '_blank');
    win?.focus();
  } else {
    history.push(url);
  }
}

export const urlPatternValidation = (URL: string) => {
  if (!URL) {
    return false;
  }
  return validator.isURL(URL);
};

export function removeHTML(str) {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = str;
  const tagsFreeResult = tmp.textContent || tmp.innerText || '';
  return tagsFreeResult.replace(/(\r\n|\n|\r)/gm, '');
}

export function validatePriceFormat(numStr) {
  if (!numStr) return false;
  const regex = /^\d+(?:\.\d{1,2})$/;
  return regex.test(numStr);
}

const isValidPercent = (value: string | undefined | null | number) => {
  return !value || (0 <= +value && +value <= 100);
};

export const validateBookingOptionFields = (
  bookingOption: Partial<BookingOption> | null,
  noMaximumAttendees: boolean
): boolean => {
  if (!bookingOption) return false;
  const {
    subType,
    location,
    locationType,
    pricingModel,
    title,
    attendeesMinimum,
    attendeesMaximum,
    price,
    taxRate,
    additionalCharges,
  } = bookingOption;

  if (!pricingModel) return false;
  if (!title) return false;
  if (!subType) return false;

  if (!validatePriceFormat(price)) return false;

  if (!isValidPercent(taxRate) || !taxRate) return false;

  const isValidAdditionalCharges = (additionalCharges || []).every(charge =>
    isValidPercent(charge.percent)
  );
  if (!isValidAdditionalCharges) return false;

  if (subType !== 'addon') {
    if (!locationType) return false;
    if (locationType === LocationType.vendorLocation && !location) return false;
  }

  if (pricingModel === 'person') {
    if (!attendeesMinimum) return false;
    if (!attendeesMaximum && !noMaximumAttendees) return false;
  }

  return true;
};

export function escapeQuote(literal) {
  if (typeof literal === 'string' && literal.includes('"')) {
    return literal.replace(/"/g, '""');
  }
  return literal;
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export function isNumeric(str) {
  if (typeof str !== 'string') return false;
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return !isNaN(str) && !isNaN(parseFloat(str));
}

export const timestampToDateString = (
  timestamp: number,
  tz?: string,
  format: string = 'MMM DD YYYY hh:mm A z'
) => {
  const date = moment(timestamp);
  if (tz) return date.tz(tz).format(format);
  return date.format(format);
};

const maxSlugTextLength = 60;
const whitespacePattern = /\s/g;
const notWordOrUnderscorePattern = /[\W_]+/g;

export function replaceSpaces(
  string: string,
  replaceValue: string = '-'
): string {
  return string.replace(/\s/g, replaceValue);
}

export function createSlug(text: string): string {
  return text
    .slice(0, maxSlugTextLength)
    .replace(notWordOrUnderscorePattern, ' ')
    .trim()
    .replace(whitespacePattern, '-')
    .toLowerCase();
}

export const promiseLikeSetState = (setStateFn, state) =>
  new Promise<void>(resolve => setStateFn(state, resolve));

const formatter = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  style: 'currency',
});

/**
 * Converts a number to a currency string.
 *
 * ```ts
 * convertNumberToUSD(12345.6789); // $12,345.68
 * ```
 * @param num
 * @returns
 */
export const convertNumberToUSD = (num: number) => {
  return formatter.format(num);
};

export const isNotUndefined = <T>(value: T): value is NonNullable<T> =>
  value !== undefined;

export const ensureEndsWith = (str: string, ending: string) =>
  str.endsWith(ending) ? str : str + ending;
